import Vue from 'vue'

import Button from '@/components/button/basic-button.vue'

export default Vue.extend({
  name: 'Modal',

  props: {
    title: {
      type: String as Prop<string>
    },
    persistent: {
      type: Boolean as Prop<boolean>,
      default: true
    },
    color: {
      type: String as Prop<string>,
      default: '#FFFFFF'
    },
    bgColor: {
      type: String as Prop<string>,
      default: '#385278'
    }
  },

  components: {
    'v-button': Button
  },

  data () {
    return {
      dialog: true,
      headerStyle: {
        'color': this.color,
        'background-clor': this.bgColor
      }
    }
  },

  watch: {
    dialog (val) {
      if (!val) {
        this.handleClose()
      }
    }
  },

  methods: {
    handleClose () {
      this.$emit('close')
    }
  }
})
